/**
 * @file paddlejs consult
 * @author wanzhongyun
 */

import React from 'react';
import { IPaddleJsConsult } from './../../type';

import './style.less';

const PaddleJSConsult: React.FC<IPaddleJsConsult> = props => {

    const { title, caseList } = props;

    return <div className='paddle-js-consult-wrapper'>
        <div className='paddle-js-consult-title'>{title}</div>
        <div className='paddle-js-consult-card-wrapper'>
        {
            caseList.map(item => <div className='paddle-js-consult-card' key={item.title}>
                <div className='paddle-js-consult-card-title'>{ item.title }</div>
                <div className='paddle-js-consult-card-desc'>{ item.desc }</div>
                <a className='paddle-js-consult-card-link' href={item.btnLink} target='_blank' rel='noreferrer' >{item.bthWord}</a>
            </div>)
        }
        </div>
    </div>
};

export default PaddleJSConsult;